import { WorkingWithUsSectionStyles } from '../section.style';
import { ContentBlock } from '@exploration/shared-components';
import Image from 'next/image';

export interface FinancialPlanSectionProps {
  headline: string;
  subHeadline: string;
  content: string[];
  image?: {
    alt: string;
    source: {
      publicUrl: string;
    };
  };
}

const FinancialPlanSection = ({
  headline,
  subHeadline,
  content,
  image,
}: FinancialPlanSectionProps) => {
  const { Container, Content } = WorkingWithUsSectionStyles;

  return (
    <Container>
      <ContentBlock
        headline={headline}
        subHeadline={subHeadline}
        checkMarkItems={content}
      />
      <Content>
        {image && (
          <Image
            src={image.source.publicUrl}
            alt={image.alt}
            width={588}
            height={358}
            style={{ width: '100%', height: '100%' }}
          />
        )}
      </Content>
    </Container>
  );
};

export default FinancialPlanSection;
